import type { DestinationID } from "@pdfking/imposition"
import type { Distance, Rectangle } from "@pdfking/math"
import type { CompletePage, Page } from "@pdfking/renderer-api"

// A toggleable preview overlay — a destination (front/rear/plate) or the guide
// marks. The caller flips `active` and the page draws what is active.
export type GuideId = string
export type Guide = {
  id: GuideId
  // Destination label (empty for the marks guide — caller labels it via i18n).
  name: string
  kind: "destination" | "marks"
  active: boolean
}

// The marks guide's id. Fixed (destinations are named by the imposition, this
// one is not), so a host can name it without hunting through the guides — e.g.
// to start a viewer with it flipped from its default.
export const MARKS_GUIDE: GuideId = "@marks"

// A sheet as the viewer lays it out: its geometry up front, its shapes drawn
// only once it scrolls into view, for the guides active then.
export type LazyPage = Omit<CompletePage, "shapes"> & {
  get_page: (active_guides?: Guide[]) => Page
}

// What the form panels read off the current result: the guides, which
// destinations a file row may target, and the size artwork scales into.
export type ResultContext = {
  file_destinations: Set<DestinationID>
  guides: Guide[]
  sample_media: Rectangle<Distance> | undefined
}
